export const firebaseConfig = {
    apiKey: "AIzaSyCbhC8dnw6NrIEW2jJ_GJgTxiONb_r8pKo",
    authDomain: "olx-new-949c5.firebaseapp.com",
    projectId: "olx-new-949c5",
    storageBucket: "olx-new-949c5.appspot.com",
    messagingSenderId: "1092179284378",
    appId: "1:1092179284378:web:129d5cd48ebced25966a23",
    measurementId: "G-5V42DSD9KS"
  };